import { z } from 'zod';

export interface BrandApi {
  id: string;
  name: string;
  createdAt?: string;
  updatedAt?: string;
}

export const brandSchema = z.object({
  name: z.string().min(1, 'Debes ingresar un nombre de marca'),
});

export type BrandSchema = z.infer<typeof brandSchema>;

export const defaultBrandValues: BrandSchema = {
  name: '',
}; 